import React from 'react';

const StormContext = React.createContext({});

export default StormContext;
